import React from "react";
import LinkHandler from "./LinkHandler";


export const Reviews = ({ data }) => {
  const renderCategory = (title, reviews, description) => (
    <div className="reviews-category">
      <h3 className="text-center">{title}</h3>
      {description && <div className="reviews-description text-center">{description}</div>}
      {Array.isArray(reviews) && reviews.length > 0 ? (
        <div className="row">
          {reviews.map((d, i) => (
            <div key={`${d.name}-${i}`} className="col-md-4">
              <div className="reviews">
                <div className="reviews-image">
                  <img src={d.img} alt={d.alt} />
                </div>
                <div className="reviews-content">
                  <p>"{d.text}"</p>
                  <div className="reviews-meta">
                    <div className="reviews-name">– {d.name}</div>
                    <div className="reviews-date">{d.date}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>Нет отзывов...</p>
      )}
    </div>
  );

  return (
    <div className="reviews">
      <div className="container">
        <div className="section-title section-title-link text-center">
          <h2>Отзывы клиентов о компании</h2>
          <p>Мы гордимся своей работой и ценим доверие наших клиентов!</p>
        </div>

        <div className="reviews-container">
          <div className="reviews-left">
            <h3>Про наши отзывы</h3>
            <p>На этой странице вы найдёте отзывы о нашей работе, подтверждающие качество предоставляемых услуг. Если у вас возникли вопросы, вы всегда можете связаться с нами через <LinkHandler href="/contacts" title="Пролистать разделу с контактами">контакты</LinkHandler>, чтобы уточнить детали.</p>
            <p><strong>Почему важно читать отзывы?</strong></p>
            <p>Отзывы помогают вам понять, как мы работаем, и увериться в том, что мы соответствуем ожиданиям.</p>
            <p><strong>Хотите оставить свой отзыв?</strong></p>
            <p>Перейдите на страницу с объявлением на Авито, Яндексе или Google по ссылкам с описаниями под каждой категорией, где вы сможете убедиться в реальности этих отзывов, а также оставить свой отзыв о выполненной нами работе.</p>
          </div>
          <div className="reviews-right">
            <h3>Последние обновления</h3>
            <p>Отзывы актуальны на <strong>октябрь 2025</strong> года. Мы регулярно обновляем эту страницу, чтобы вы могли видеть самые свежие комментарии.</p>
            <h3>Часто задаваемые вопросы (ЧаВо)</h3>
            <p><strong>Как мы собираем отзывы?</strong></p>
            <p>Мы принимаем их через проверенные платформы, такие как Авито, чтобы гарантировать их подлинность.</p>
            <p><strong>Будете ли вы принимать отзывы у себя на вебсайте?</strong></p>
            <p>Мы считаем, что нет особого смысла принимать отзывы прямо на <LinkHandler href="/" title="Пролистать на главную (на самый верх)">нашем сайте</LinkHandler>, когда существуют надёжные и проверенные сторонние площадки.</p>
          </div>
        </div>

        {/* Render all categories */}
        {renderCategory(
          "Отзывы на Авито",
          data["Reviews-Avito"],
          <p>✔️ Посмотрите наши <LinkHandler href="https://www.avito.ru/sankt-peterburg/predlozheniya_uslug/udalenie_tsarapin_v_lifte_3063808631#open-reviews-list" title="Посмотреть все отзывы на Avito">отзывы на Авито</LinkHandler>, убедившись в качестве наших услуг.</p>
        )}

        {renderCategory(
          "Отзывы в Яндексе",
          data["Reviews-Yandex"],
          <p>✔️ Ознакомьтесь с <LinkHandler href="https://yandex.ru/maps/org/lift_blesk/205131178461/reviews" title="Ознакомиться с отзывами в Яндексе">отзывами в Яндексе</LinkHandler> и узнайте мнение наших клиентов о работе.</p>
        )}

        {renderCategory(
          "Отзывы из Google",
          data["Reviews-Google"],
          <p>✔️ Оцените надёжность и профессионализм нашей компании, благодаря <LinkHandler href="https://www.google.com/search?q=lift+blesk+%D1%81%D0%B0%D0%BD%D0%BA%D1%82-%D0%BF%D0%B5%D1%82%D0%B5%D1%80%D0%B1%D1%83%D1%80%D0%B3+%D0%BE%D1%82%D0%B7%D1%8B%D0%B2%D1%8B&sca_esv=f59e2138defda713&rlz=1C1GCEA_enRU1087RU1087&cs=0&filter=0&biw=1920&bih=953&dpr=1" title="Открыть отзывы из Google">отзывам из Google</LinkHandler>.</p>
        )}

      </div>
    </div>
  );
};
